import * as XLSX from 'xlsx';
export const readDataFile = (file) => {
  return new Promise((resolve, reject) => {
    try {
      const fileReader = new FileReader();
      const extension = file.name.toLowerCase().split('.').slice(-1)[0];
      fileReader.readAsBinaryString(file);
      fileReader.onload = (e) => {
        switch (extension) {
          case 'xlsx':
          case 'xls':
            resolve(getDataByXls(e.target.result));
            break;
        }
      };
    } catch (error) {
      reject(error);
    }
  });
};

const getDataByXls = (content) => {
  const wb = XLSX.read(content, { type: 'binary', cellDates: true, cellText: false});
  if (wb.SheetNames.length > 0) {
    const ws = wb.Sheets[wb.SheetNames[0]];
    return XLSX.utils.sheet_to_json(ws, { header: 'A', raw: false, dateNF: 'yyyy-mm-dd', rawNumbers: true});
  }
};
